export enum DocumentHintNames {
  TAGS = 'tags',
  SEGMENTS = 'segments',
}
